/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rg_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Random numbers & UUIDs`)
};

const es_rg_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Números aleatorios y UUIDs`)
};

const de_rg_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zufallszahlen & UUIDs`)
};

const nl_rg_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Willekeurige nummers en UUIDs`)
};

const fr_rg_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombres aléatoires et UUID`)
};

const it_rg_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numeri casuali e UUID`)
};

const pt_br2_rg_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Números aleatórios e UUIDs`)
};

const pt_rg_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Números aleatórios e UUIDs`)
};

const ja_rg_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ランダム番号とUUID`)
};

const zh_rg_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`随机数与UUID`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rg_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rg_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rg_nav_main_desc", locale)
	if (locale === "en") return en_rg_nav_main_desc(inputs)
	if (locale === "es") return es_rg_nav_main_desc(inputs)
	if (locale === "de") return de_rg_nav_main_desc(inputs)
	if (locale === "nl") return nl_rg_nav_main_desc(inputs)
	if (locale === "fr") return fr_rg_nav_main_desc(inputs)
	if (locale === "it") return it_rg_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_rg_nav_main_desc(inputs)
	if (locale === "pt") return pt_rg_nav_main_desc(inputs)
	if (locale === "ja") return ja_rg_nav_main_desc(inputs)
	return zh_rg_nav_main_desc(inputs)
};